<app-header></app-header>
<!-- <ngx-spinner></ngx-spinner> -->
<div class="page-wrapper wrapper">
    <section class="page-top-header content-banner">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-7">
                    <h2 class="mb-2">{{"PAYMENT_INFO.SUBSCRIBE_NOW"|translate}}</h2>
                    <p>{{"PAYMENT_INFO.MESSAGE"|translate}}</p>
                </div>
            </div>
        </div>
    </section>

    <section class="user-plan">
        <div class="container">
            <div class="row justify-content-center align-items-center">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="plan-box credit-card text-center gray-bg">
                        <div class="mt-3 mb-4">
                            <h4 class="credit-heading">{{"PAYMENT_INFO.PAYMENT"|translate}}</h4>
                            <p class="per-month">
                                {{"PAYMENT_INFO.ENTER_CARD_DETAIL"|translate}}
                            </p>
                        </div>

                        <div class="mb-3">
                            <div *ngIf="invalidError" style="color:red">
                                {{ invalidError.message }}
                            </div>
                            <div class="form-group form-border">
                                <stripe-card #stripeCard (catch)="onStripeError($event)" [(invalid)]="invalidError"
                                    (cardMounted)="cardReady" (tokenChange)="setStripeToken($event)"
                                    (sourceChange)="setStripeSource($event)"></stripe-card>
                            </div>

                        </div>
                        <button class="btn select-btn" (click)="getToken()" [disabled]="btnDisable">
                            {{"PAYMENT_INFO.PAY_NOW"|translate}}
                        </button>
                    </div>
                </div>
                <!-- <div class="text-center">
                    <button class="btn btn-link" (click)="planShow()">Change Plan</button>
                </div> -->
            </div>
        </div>
    </section>
</div>
<app-footer></app-footer>